import {connect} from "react-redux";
import CreateMeeting from "./CreateMeeting";
import {bindActionCreators} from "redux";
import {getExistingSites} from "../../../../service/Valet/action";
import { documentUploadUrlPublic } from "../../../../service/fileUpload/action";
import { markAttendance } from "../../../../service/DCC/action";
import {saveSiteVisit} from "../../../../service/Valet/action";
import {getPendingActivity} from "../../../../service/BA/action";
import {isCheckout} from "../../../../service/CarService/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    activityTypesDetails:state.Dealer.activityTypesDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    existingSiteDetails:state.Valet.existingSiteDetails,
    projectById:state.Valet.projectById,
    attendance:state.BA.attendance,
    siteVisit:state.Valet.siteVisit,
    isCheckoutDetails:state.CarService.isCheckout,
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityTypes,
            getExistingSites,
            markAttendance,
            documentUploadUrlPublic,
            saveSiteVisit,
            isCheckout,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateMeeting);
